export default __webpack_public_path__ + "static/media/gab2.1a421100.png";